export default __webpack_public_path__ + "static/big-purchases-919d3a7ae6fdc14a6160fd5bcc5e98e1.webp";